import { root, id } from './onboard';

export const onboard = {
  ...root,
  id,
};
